<template>

  <b-card bg-variant="light">
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">

      <b-form-row>
        <b-col md="3">
          <b-form-group
            id="from-phone-group"
            label="Вызывающий абонент:"
            label-for="from-phone"
            description="Поиск по вхождению подстроки"
          >
            <b-form-input
              id="from-phone"
              type="text"
              v-model="params['from-number']"
              placeholder="79001002030"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            id="to-phone-group"
            label="Вызываемый абонент:"
            label-for="to-phone"
            description="Поиск по вхождению подстроки"
          >
            <b-form-input
              id="to-phone"
              type="text"
              v-model="params['to-number']"
              placeholder="79001002030"
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            id="call-status-group"
            label="Статус звонка:"
            label-for="call-status"
          >
            <b-form-select
              id="call-status"
              v-model="params['status']"
              :options="statuses"></b-form-select>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            id="has-recording-group"
            label="Запись разговора:"
            label-for="has-recording"
          >
            <b-form-radio-group
              id="has-recording"
              v-model="params['has-recording']"
            >
              <b-form-radio value="">Не важно</b-form-radio>
              <b-form-radio value="yes">Есть</b-form-radio>
              <b-form-radio value="no">Нет</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            id="date-from-group"
            label="Дата от:"
            label-for="date-from"
          >
            <b-form-datepicker
              id="date-from"
              placeholder="Выберите дату"
              locale="ru"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              v-model="params['date-from']"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            id="date-from-group"
            label="Дата до:"
            label-for="date-from"
          >
            <b-form-datepicker
              id="date-to"
              placeholder="Выберите дату"
              locale="ru"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              v-model="params['date-to']"
            ></b-form-datepicker>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            id="direction-group"
            label="Тип"
            label-for="direction"
          >
            <b-form-radio-group
              id="direction"
              v-model="params['direction']"
            >
              <b-form-radio value="">Все</b-form-radio>
              <b-form-radio value="incoming">Входящие</b-form-radio>
              <b-form-radio value="outgoing">Исходящие</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>

      </b-form-row>

      <b-form-row>
        <b-col>
          <b-button-group>
            <b-button type="submit" variant="primary">
              <fa-icon icon="search"/> Поиск
            </b-button>
            <b-button type="reset" variant="danger">
              <fa-icon icon="times-circle"/> Сбросить
            </b-button>
          </b-button-group>
        </b-col>
      </b-form-row>

    </b-form>
  </b-card>

</template>

<script>
import Utils from '@/lib/Utils';


export default {
    name: 'CallFilter',
    props: [
        'query'
    ],
    data () {
        return {
            params: this.query,
            formKeys: ['from-number', 'to-number',
                       'status', 'has-recording',
                       'date-from', 'date-to',
                       'direction'],
            statuses: Utils.callStatusChoices()
        }
    },
    methods: {
        onSubmit () {
            const params = Object.assign({}, this.params);
            delete params['from-id'];
            delete params['to-id'];
            this.params = params;
            this.$emit('search', params);
        },
        onReset () {
            const params = Object.assign({}, this.params);
            this.formKeys.forEach(k => {
                delete params[k];
            });
            this.params = params;
            this.onSubmit();
        },
    },
};
</script>
